<template>

  <div>
    <div class="card mb-4">
      <div class="card-header">
        {{ $t('General information') }}
      </div>
      <div class="card-body">
        <div class="row">
          <div
            :class="!job.is_talent_pool ? 'col-sm-10' : 'col-sm-12'">
            <div class="form-group">
              <label class="control-label">* {{ $t('Title') }}</label>
              <input v-autofocus class="form-control" type="text" v-model="job.title">
              <ValidateMessage :error="validateErrors.title" />
            </div>
          </div>
          <div
            v-if="!job.is_talent_pool"
            class="col-sm-2">
            <div class="form-group">
              <label class="control-label">* {{ $t('Number of openings') }}</label>
              <input class="form-control" type="text" v-model="job.openings">
              <ValidateMessage :error="validateErrors.openings" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Company') }}</label>
              <select-company v-model="job.company_id" @inputObject="setAddress"></select-company>
              <ValidateMessage :error="validateErrors.company_id" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Department') }}</label>
              <select-departament v-model="job.departament_id"></select-departament>
              <ValidateMessage :error="validateErrors.departament_id" />
            </div>
          </div>
        </div>

        <div
          v-if="!job.is_talent_pool"
          class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Hiring manager') }}</label>

              <div class="input-group">
                <input type="text" class="form-control" :placeholder="$t('Name')" v-model="job.hiring_manager_name">
                <input type="text" class="form-control" :placeholder="$t('Email')" v-model="job.hiring_manager_email">
              </div>
              <ValidateMessage :error="validateErrors.hiring_manager_name" />
              <ValidateMessage :error="validateErrors.hiring_manager_email" />

            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Owner') }}</label>
              <select-user v-model="job.owner_user_id"></select-user>
              <ValidateMessage :error="validateErrors.owner_user_id" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('Tags') }}</label>
              <SetTag
                type="job"
                enable
                v-model="job.tags" />
              <ValidateMessage :error="validateErrors.tags" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Career site') }}</label>
              <select-careersite v-model="job.careersite_id"></select-careersite>
              <ValidateMessage :error="validateErrors.careersite_id" />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        {{ $t('Location') }}
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">
                <span v-if="!job.is_talent_pool">*</span>
                {{ $t('Country') }}
              </label>
              <select-country v-model="job.country"></select-country>
              <ValidateMessage :error="validateErrors.country" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">
                <span v-if="!job.is_talent_pool">*</span>
                {{ $t('State') }}
              </label>
              <input class="form-control" type="text" v-model="job.region">
              <ValidateMessage :error="validateErrors.region" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">
                <span v-if="!job.is_talent_pool">*</span>
                {{ $t('City') }}
              </label>
              <input class="form-control" type="text" v-model="job.city">
              <ValidateMessage :error="validateErrors.city" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('Neighborhood') }}</label>
              <input class="form-control" type="text" v-model="job.neighborhood">
              <ValidateMessage :error="validateErrors.neighborhood" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('Address') }}</label>
              <input class="form-control" type="text" v-model="job.address">
              <ValidateMessage :error="validateErrors.address" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('Zip code') }}</label>
              <input class="form-control" type="text" v-model="job.zipcode">
              <ValidateMessage :error="validateErrors.zipcode" />
            </div>
          </div>
        </div>

        <div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="on-site"
              value="on-site"
              v-model="job.workplace_type">
            <label
              class="form-check-label"
              for="on-site">
              {{ $t('On-site') }}
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="remote"
              value="remote"
              v-model="job.workplace_type">
            <label
              class="form-check-label"
              for="remote">
              {{ $t('Remote') }}
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="hybrid"
              value="hybrid"
              v-model="job.workplace_type">
            <label
              class="form-check-label"
              for="hybrid">
              {{ $t('Hybrid') }}
            </label>
          </div>
        </div>
        <ValidateMessage :error="validateErrors.workplace_type" />

      </div>
    </div>

    <JobModalDescription
      v-if="generate_description"
      @cancel="generate_description = false"
      :value="job"
      @input="setJobDescription" />
    <div class="mb-2">
      <button
        type="button"
        @click="generate_description = true"
        class="btn btn-outline-primary">{{ $t('Generate job description (ChatGPT)')  }}</button>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        * {{ $t('Description') }}
      </div>
      <textarea-editable
        v-model="job.description"
        editor-model="html"
        :enable-link="true"
        :enable-img="true"></textarea-editable>
      <ValidateMessage :error="validateErrors.description" />
      <div class="card-header">
        * {{ $t('Requirements') }}
      </div>
      <textarea-editable
        v-model="job.requirements"
        editor-model="html"
        :enable-link="true"
        :enable-img="true"></textarea-editable>
      <ValidateMessage :error="validateErrors.requirements" />
      <div class="card-header">
        {{ $t('Benefits') }}
      </div>
      <textarea-editable
        v-model="job.benefits"
        editor-model="html"
        :enable-link="true"
        :enable-img="true"></textarea-editable>
      <ValidateMessage :error="validateErrors.benefits" />
    </div>

    <div
      v-if="!job.is_talent_pool"
      class="card mb-4">
      <div class="card-header">
        {{ $t('Remuneration') }}
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Currency') }}</label>
              <select-currency v-model="job.currency"></select-currency>
              <ValidateMessage :error="validateErrors.currency" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('From') }}</label>
              <input-money 
                v-model="job.remuneration"
                :locale="$i18n.locale"
                :placeholder="$n(0, {style: 'decimal', minimumFractionDigits: 2})">
                </input-money>
              <ValidateMessage :error="validateErrors.remuneration" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('To') }}</label>
              <input-money 
                v-model="job.remuneration_max"
                :locale="$i18n.locale"
                :placeholder="$n(0, {style: 'decimal', minimumFractionDigits: 2})">
                </input-money>
              <ValidateMessage :error="validateErrors.remuneration_max" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">{{ $t('Per') }}</label>
              <select class="form-control" v-model="job.remuneration_period">
                <option value="year">{{ $t('Year') }}</option>
                <option value="month">{{ $t('Month') }}</option>
                <option value="hour">{{ $t('Hour') }}</option>
              </select>
              <ValidateMessage :error="validateErrors.remuneration_period" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">* {{ $t('Contract type') }}</label>
              <select-contract v-model="job.contract_id"></select-contract>
              <ValidateMessage :error="validateErrors.contract_id" />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        {{ $t('Details') }}
      </div>
      <div class="card-body">
        
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">
                <span v-if="!job.is_talent_pool">*</span>
                {{ $t('Professional category') }}
              </label>
              <select-position-category v-model="job.position_category"></select-position-category>
              <ValidateMessage :error="validateErrors.position_category" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">
                <span v-if="!job.is_talent_pool">*</span>
                {{ $t('Experience level') }}
              </label>
              <select-experience-level v-model="job.experience_level"></select-experience-level>
              <ValidateMessage :error="validateErrors.experience_level" />
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <label class="control-label">
                <span v-if="!job.is_talent_pool">*</span>
                {{ $t('Last education') }}
              </label>
              <select-education-degree v-model="job.education_degree"></select-education-degree>
              <ValidateMessage :error="validateErrors.education_degree" />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header">
        {{ $t('Internal Comments') }}
      </div>
      <textarea class="form-control" rows="5" v-model="job.comments"></textarea>
      <ValidateMessage :error="validateErrors.comments" />
    </div>

    <custom-form
      v-if="!job.is_talent_pool" 
      :initCustomFields="job.custom_fields" 
      :modelType="'job'"
      :validateErrors="validateErrors"
      @changed="$set(job, 'custom_fields', arguments[0])">
      </custom-form>

  </div>

</template>

<script>
import CustomForm from '@/components/Parts/CustomForm'
import SelectUser from '@/components/Fields/SelectUser'
import SelectContract from '@/components/Fields/SelectContract'
import SelectCompany from '@/components/Fields/SelectCompany'
import SelectDepartament from '@/components/Fields/SelectDepartament'
import SelectCareersite from '@/components/Fields/SelectCareersite'
import SelectCountry from '@/components/Fields/SelectCountry'
import SelectCurrency from '@/components/Fields/SelectCurrency'
import SelectPositionCategory from '@/components/Fields/SelectPositionCategory'
import SelectExperienceLevel from '@/components/Fields/SelectExperienceLevel'
import SelectEducationDegree from '@/components/Fields/SelectEducationDegree'
import InputMoney from '@/components/Fields/InputMoney'
import SetTag from '@/components/Fields/SetTag'
import JobModalDescription from './JobModalDescription'

export default {
  name: 'JobFormDetails',
  components: {
    CustomForm,
    SelectUser,
    SelectContract,
    SelectCompany,
    SelectDepartament,
    SelectCareersite,
    SelectCountry,
    SelectCurrency,
    SelectPositionCategory,
    SelectExperienceLevel,
    SelectEducationDegree,
    InputMoney,
    SetTag,
    JobModalDescription
  },
  props: [
    'initJob',
    'validateErrors'
  ],
  data () {
    return {
      job: this.$clone(this.initJob),
      generate_description: false
    }
  },
  watch: {
    job: {
      handler: function (newValue) {
        const {
          is_talent_pool,
          title,
          openings,
          company_id,
          departament_id,
          hiring_manager_name,
          hiring_manager_email,
          owner_user_id,
          tags,
          careersite_id,
          country,
          region,
          city,
          neighborhood,
          address,
          zipcode,
          workplace_type,
          description,
          requirements,
          benefits,
          currency,
          remuneration,
          remuneration_max,
          remuneration_period,
          contract_id,
          position_category,
          experience_level,
          education_degree,
          comments,
          custom_fields
        } = newValue

        this.$emit('changed', {
          is_talent_pool,
          title,
          openings,
          company_id,
          departament_id,
          hiring_manager_name,
          hiring_manager_email,
          owner_user_id,
          tags,
          careersite_id,
          country,
          region,
          city,
          neighborhood,
          address,
          zipcode,
          workplace_type,
          description,
          requirements,
          benefits,
          currency,
          remuneration,
          remuneration_max,
          remuneration_period,
          contract_id,
          position_category,
          experience_level,
          education_degree,
          comments,
          custom_fields
        })
      },
      deep: true
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    }
  },
  methods: {
    setAddress (params) {
      this.job = Object.assign(this.job, {
        country: params.country,
        region: params.region,
        city: params.city,
        neighborhood: params.neighborhood,
        address: params.address,
        zipcode: params.zipcode
      })
    },
    setJobDescription (data) {
      this.job = {
        ...this.job,
        title: data.title,
        description: data.description,
        requirements: data.requirements,
        benefits: data.benefits
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormDetails.vue